export const columnWidths = {
  col1: '64px',
  col2: '160px',
  col3: '256px',
  col4: '352px',
  col5: '448px',
  col6: '544px',
  col7: '640px',
  col8: '736px',
  col9: '832px',
  col10: '928px',
  col11: '1024px',
  col12: '1120px',
  col13: '1216px',
  col14: '1312px',
  col15: '1408px',
  col16: '1504px',
} as const;

export type IColumnWidth = keyof typeof columnWidths;
